import { useEffect } from "react";
import { isFirefox } from "react-device-detect";

/**
 * @see: https://stackoverflow.com/a/36096145/7689963
 */
const useDisableOverscroll = (classname) => {
  useEffect(() => {
    if (!isFirefox) {
      return undefined;
    }

    const scroll = (event) => {
      if (event.target && event.target.classList.contains(classname)) {
        const element = event.target;
        const delta = event.type === "mousewheel" ? event.wheelDelta : event.detail * -40;
        if (delta < 0 && element.scrollHeight - element.offsetHeight - element.scrollTop <= 0) {
          element.scrollTop = element.scrollHeight;
          event.preventDefault();
        } else if (delta > 0 && delta > element.scrollTop) {
          element.scrollTop = 0;
          event.preventDefault();
        }
      }
    };

    document.addEventListener("mousewheel", scroll);
    document.addEventListener("DOMMouseScroll", scroll);

    return () => {
      document.removeEventListener("mousewheel", scroll);
      document.removeEventListener("DOMMouseScroll", scroll);
    };
  }, [classname]);
};

export default useDisableOverscroll;
